import Footer from "./Footer";
import {Image} from "react-bootstrap";
import './StudentsGallery.css';

let ErasmusDaysGallery = () => {
    const verticalImageList = [   
    ]

    const horizontalImageList = [
        "img_002.jpg",
        "img_003.jpg",
        "img_004.jpg",
        "img_006.jpg",
        "img_007.jpg",
        "img_008.jpg",
        "img_009.jpg",
        "img_010.jpg",
        "img_011.jpg",
        "img_012.jpg",
        "img_013.jpg",
        "img_014.jpg",
        "img_015.jpg",
        "img_017.jpg",
        "img_018.jpg",
        "img_019.jpg",
        "img_020.jpg"
    ]

    return(
        <div className="content text-center">
            
            <div>
                {horizontalImageList.map(path => <Image className="imageHorizontal m-3" src={require("./img/galeria-erasmusdays/" + path)} rounded />)}
            </div>

            <div>
                {verticalImageList.map(path => <Image className="imageVertical m-3" src={require("./img/galeria-erasmusdays/" + path)} rounded />)}
            </div>

        </div>
    )
}

export default ErasmusDaysGallery;